import { memo } from 'react'
import { TIME_INTERVAL } from '$features/calendar/constants'
import { Slot } from '$features/calendar/hooks/use-calendar-slots'

type TimeSlotsProps = {
  timeSlots: Slot[]
  startingTimeIndex: number
}

export const TimeSlots = memo(function TimeSlots({
  timeSlots,
  startingTimeIndex,
}: TimeSlotsProps) {
  return (
    <>
      {timeSlots.map((slot, index) => (
        <div
          key={slot.id}
          className="sticky left-0 z-10 bg-white border-r border-b border-gray-100"
          style={{ gridColumn: '1 / 2', gridRowStart: index + 2 }}
        >
          {(index + startingTimeIndex) % (60 / TIME_INTERVAL) === 0 && (
            <p className="absolute bottom-0 -translate-y-[100%] text-gray-700 text-xs right-2">
              {slot.finish.format('h A')}
            </p>
          )}
        </div>
      ))}
    </>
  )
})